// jsdom's Blob has no .text() — read via FileReader so specs work too.
async function readBlobText(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '');
    reader.onerror = () => reject(reader.error ?? new Error('blob read failed'));
    reader.readAsText(blob);
  });
}

export async function extractBlobErrorMessage(err: unknown, fallback: string): Promise<string> {
  const error = (err as { error?: unknown } | null)?.error;
  if (error instanceof Blob) {
    try {
      const parsed = JSON.parse(await readBlobText(error)) as { errors?: unknown };
      if (Array.isArray(parsed.errors) && parsed.errors.length > 0) {
        return String(parsed.errors[0]);
      }
    } catch {
      // not JSON — fall through to fallback
    }
  }

  return fallback;
}
